import React, { useState } from 'react';
import { LearningCenterQueryData, LearningCenterItem } from '../types';

const getTitle = (item: LearningCenterItem): string => {
    if ('ArticleTitle' in item) {
        return item.ArticleTitle;
    } else if ('Name' in item) {
        return item.Name;
    }
    return 'Untitled';
};

interface SearchResultsProps {
    results: LearningCenterQueryData;
}

const SearchResults: React.FC<SearchResultsProps> = ({ results }) => {
    const items = results?.Content?.items || [];
    const [selectedVideo, setSelectedVideo] = useState<LearningCenterItem | null>(null);

    const handleVideoClick = (e: React.MouseEvent<HTMLAnchorElement>, item: LearningCenterItem) => {
        e.preventDefault();
        setSelectedVideo(item);
    };

    const isVideoItem = (item: LearningCenterItem): boolean => {
        return (
            item.__typename === "VideoFile" ||
            ('YoutubeId' in item && !!item.YoutubeId) ||
            ('VimeoId' in item && !!item.VimeoId)
        );
    };


    const getVideoUrl = (item) => {
        if (item.YoutubeId) {
            const autoplay = item.YoutubeAutoPlay ? "&autoplay=1" : "";
            return `https://www.youtube.com/embed/${item.YoutubeId}?rel=0&showinfo=0${autoplay}`;
        }
        if (item.VimeoId) {
            return `https://player.vimeo.com/video/${item.VimeoId}`;
        }
        return "";
    };



    return (
        <>
            <div id="learning-center-search-results">
                {items.length ? (
                    <ul>
                        {items.map((result, index) => {
                            const isVideo = isVideoItem(result);
                            return (
                                <li className="search-result-item" key={result.Url ? `${result.Url}-${index}` : index}>
                                    {isVideo ? (
                                        <a href="#" onClick={(e) => handleVideoClick(e, result)}>
                                            {getTitle(result)}
                                        </a>
                                    ) : (
                                        <a href={result.Url} target="_blank" rel="noopener noreferrer">
                                            {getTitle(result)}
                                        </a>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <div id="learning-center-search-results">
                        <p>No results found.</p>
                    </div>
                )}
            </div>

            {selectedVideo && isVideoItem(selectedVideo) && (
                <div
                    className="search-modal-overlay"
                    onClick={() => setSelectedVideo(null)}
                >
                    <div
                        className="search-modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <button
                            className="search-modal-close"
                            onClick={() => setSelectedVideo(null)}
                            aria-label="Close video"
                        >
                            &times;
                        </button>
                        {selectedVideo.__typename === "VideoFile" ? (
                            <video
                                src={getVideoUrl(selectedVideo)}
                                controls
                                className="search-modal-video"
                            >
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <iframe
                                width="100%"
                                height="100%"
                                src={getVideoUrl(selectedVideo)}
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                                title="Embedded video"
                            />
                        )}

                    </div>
                </div>
            )}
        </>
    );
};

export default SearchResults;
